module.exports = __webpack_public_path__ + "static/media/portal-antes-depois.7af90eb7.webp";